import React from "react";
const GestionArchivos = ({setGestionarArchivos}) => {

    const ingresarArchivos = () => {
        setGestionarArchivos(true); 
    };
    return (
        // Contenido para usuarios autenticados
        <div className="card shadow-lg p-3 mb-5 bg-white rounded w-100">
            <h3 className="text-center mb-4">Gestión de Archivos</h3>
            <div className="card-body ">
                <div class="row">
                    <div class="col-12">
                        <p className="text-center">
                            puede gestionar los archivos aquí.
                        </p>

                    </div>
                    <div class="col-12 d-flex justify-content-center">
                        <button className="btn btn-danger mt-3" onClick={ingresarArchivos}>
                            Ingresar
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
}
export default GestionArchivos;